const locale = {
  DUPLICATE_OF: '复制自',
  DUPLICATED_BY: '被复制',
  RELATED_TO: '相关于',
  SPLIT_TO: '拆分至',
  SPLIT_FROM: '拆分自',
  BLOCKED_BY: '被阻止',
  BLOCKS: '阻止',
  MORE_THAN: '大于',
  LESS_THAN: '小于',
  OPEN: '开放',
  IN_PROGRESS: '进行中',
  ON_HOLD: '暂停',
  COMPLETE: '完成',
  'home.built': '为简化维护管理而构建',
  home_description:
    '当白板和便利贴变成混乱，而您需要一个足够简单让团队真正使用的CMMS软件时 - 试试{{shortBrandName}}',
  try_grash: '试用{{shortBrandName}}',
  login: '登录',
  start_trial: '开始免费试用',
  'home.what': '什么',
  'home.you_will_have': '您将拥有',
  'home.you_will_have_description':
    '构建高效、可靠的工作流程，让您掌控维护工作。生成、分配和跟踪工单。控制库存。获得可靠的自动化报告，提高可见性并创建问责制。',
  key_features: '主要功能',
  key_features_description:
    '一些使{{shortBrandName}}成为当今最佳CMMS之一的功能',
  contribute: '贡献',
  work_orders: '工单',
  request_system: '工作请求系统',
  mobile_app: '移动应用',
  asset_management: '资产管理',
  preventive_maintenance: '预防性维护',
  parts_inventory: '零件库存',
  custom_dashboards: '自定义仪表板',
  'work-orders.title': '像专家一样管理您的工单',
  'work-orders.description.short': '查看和管理您的所有任务',
  'work-orders.descriptions.0':
    '厌倦了大量的文书工作和丢失的工单？所有这些丢失的项目直接影响底线和您的声誉。',
  'work-orders.descriptions.1':
    '使用{{shortBrandName}}，您可以轻松快速地在集中式数据库中组织团队的所有工单、PM和其他任务，该数据库可在任何设备上的任何地方访问。',
  'work-orders.checks.0': '查看您的所有任务，包括工单、PM和工作请求',
  'work-orders.checks.1': '设置任务优先级，以便首先完成正确的工作。',
  'work-orders.checks.2': '查看当前和即将到来的任务日历。',
  'work-orders.checks.3':
    '查看包含关键信息的工作分配，如资产信息、截止日期、优先级等。',
  'work-orders.checks.4':
    '查看关键KPI，如实际完成的工作、花费的时间以及计划与非计划工作。',

  'work-requests.title': '简化的移动工作请求系统',
  'work-requests.descriptions.0':
    '厌倦了使用导致丢失工单、持续日常中断和重复工作的旧电话和电子邮件系统？',
  'work-requests.descriptions.1':
    '{{shortBrandName}}的维护管理解决方案允许您授权的任何人通过简单扫描二维码（条形码）或访问URL并通过移动设备输入请求来向您的维护部门提交问题。',
  'work-requests.checks.0': '永远不会丢失工作。',
  'work-requests.checks.1': '减少处理工作请求的时间高达34%。',
  'work-requests.checks.2':
    '减少与请求者沟通的时间高达41%（电话、电子邮件、短信）。',

  'mobile-app.title': '增强维护团队能力的移动CMMS应用',
  'mobile-app.descriptions.0':
    '通过使用我们的Android移动应用，我们的客户在整个维护团队中体验到更好的组织、沟通、问责制和高达30%的生产力提升。',
  'mobile-app.descriptions.1': '从手持设备，维护团队的任何成员都可以：',
  'mobile-app.checks.0': '查看分配给他们的工单和PM。',
  'mobile-app.checks.1': '在60秒内记录他们的工单',
  'mobile-app.checks.2': '通过推送和电子邮件通知接收即时通信。',
  'mobile-app.checks.3': '在现场时启动新的工单。',
  'mobile-app.checks.4': '在实际处理问题时响应和记录问题',
  'mobile-app.checks.5': '在诊断问题时查找关键资产信息。',

  'eam.title': '企业资产管理',
  'eam.description.short': '了解您的资产',
  'eam.descriptions.0':
    '对试图组织公司设备的混乱状况感到沮丧，想知道设备是否得到适当维护，不知道维护成本以及管理资产带来的所有其他头痛问题？',
  'eam.descriptions.1':
    '{{brandName}}的企业资产管理模块可用于10到1,000,000个资产，让您以易于使用和可搜索的树形结构准确跟踪您想要的内容。',
  'eam.checks.0': '随时了解资产的健康状况以及它们的成本',
  'eam.checks.1': '查看完整详细的维护日志。',
  'eam.checks.2': '使用无限自定义字段仅跟踪您想要的内容',
  'eam.checks.3': '在清晰的父子层次结构中组织您的资产',
  'eam.checks.4': '使用二维码（条形码）快速轻松地查找信息',
  'eam.checks.5': '通过传感器连接获取实时资产数据。',

  'pm.title': '有效的预防性维护计划',
  'pm.descriptions.0':
    '停止浪费宝贵时间手动分发PM检查清单并跟进团队以确保工作完成。',
  'pm.descriptions.1':
    '{{shortBrandName}}允许您轻松自动化PM调度，以便在正确的时间将正确的工作自动交付给正确的技术人员处理正确的资产。',
  'pm.checks.0': '自动化PM调度为每日、每周、每月、每年，或基于事件或仪表读数。',
  'pm.checks.1': '创建或到期PM时的自动推送和电子邮件通知。',
  'pm.checks.2': '我们易于使用的日历允许您查看所有开放工作和即将到来的PM计划。',
  'pm.checks.3': '拖放更改截止日期。',
  'pm.checks.4': 'PM完成后，工作会自动记录在资产的维护日志中。',
  'pm.checks.5': '使用几乎不需要培训。',

  'part.title': '控制您的备件库存',
  'part.description.short': '知道零件何时用完',
  'part.descriptions.0':
    '不确定您有哪些零件库存或在哪里使用？不知道零件何时用完或技术人员是否有必要的零件来完成工作？',
  'part.descriptions.1':
    '我们设计{{shortBrandName}}的零件管理来解决这些问题等等：',
  'part.checks.0':
    '当零件数量不足时获得即时推送和电子邮件通知。通过在零件数量低于自定义设置阈值时接收即时和自动推送/电子邮件通知来保持正确数量的零件库存。',
  'part.checks.1':
    '技术人员从工单内部立即知道零件是否有库存。如果零件没有库存，可以轻松检查其他位置是否可用。',
  'part.checks.2':
    '自动零件使用跟踪。当工单或PM使用零件时，库存将自动更新以反映使用的零件。',
  'part.checks.3':
    '了解零件使用情况。查看零件日志以了解零件在哪里使用以及由谁使用',
  'part.checks.4': '消除未使用的零件。知道零件何时过时。',
  'part.checks.5': '实时报告。了解在哪里使用哪些零件以及它们的成本。',
  'part.checks.6': '优化库存水平。立即查看零件预测，了解明年可能使用多少零件。',
  'part.checks.7': '条形码查找。使用自定义二维码使您的库存易于跟踪和访问',

  'dashboard.title': '您的数据，您的方式，使用自定义仪表板',
  'dashboard.descriptions.0':
    '面对现实，改善运营的第一步是了解好的、坏的和丑陋的。',
  'dashboard.descriptions.1':
    '使用{{shortBrandName}}的自定义仪表板，您终于可以开始理解那个臭名昭著的"维护黑洞"，并开始实施数据支持的计划，从而降低劳动成本、减少停机时间等。',
  'dashboard.descriptions.2':
    '使用{{shortBrandName}}的自定义仪表板，您将获得...',
  'dashboard.checks.0': '知道您的钱花在哪里以及为什么',
  'dashboard.checks.1': '知道哪个资产成本最高以及为什么',
  'dashboard.checks.2': '创建您自己的自定义KPI。',
  'dashboard.checks.3': '查看根据您的指标自动生成和更新的报告',
  'dashboard.checks.4':
    '查看通过Excel表格、PDF或在{{shortBrandName}}内轻松共享的报告',
  'dashboard.checks.5': '还有更多...',
  'home.smarter': '更智能',
  'home.work': '工作',
  'home.smarter_description':
    '{{shortBrandName}}通过为技术人员提供完成工作所需的工具和数据访问权限，使他们能够高效工作变得异常简单 — 所有这些都来自他们的手掌。',
  leading_maintenance: '引领维护和可靠性更美好未来的道路',
  //register
  premium_included: '包含高级功能',
  no_credit_card: '无需信用卡',
  perfect_tool: '维护团队的完美工具',
  start_trial_today: '今天开始免费试用',
  create_account: '创建账户',
  signup_description: '填写以下字段以注册账户。',
  account_already: '已有账户？',
  signin_here: '在此登录',
  invalid_email: '提供的电子邮件应该是有效的电子邮件地址',
  required_email: '电子邮件字段是必需的',
  required_firstName: '名字字段是必需的',
  required_lastName: '姓氏字段是必需的',
  required_company: '公司名称字段是必需的',
  required_employeesCount: '请提供员工数量',
  invalid_phone: '电话号码无效',
  required_password: '密码字段是必需的',
  required_terms: '您必须同意我们的条款和条件',
  verify_email: '请检查您的电子邮件以激活您的账户',
  registration_error: '注册未成功',
  first_name: '名字',
  last_name: '姓氏',
  email: '电子邮件地址',
  phone: '电话',
  password: '密码',
  companyName: '公司名称',
  employeesCount: '员工数量',
  i_accept: '我接受',
  terms_conditions: '条款和条件',
  create_your_account: '创建您的账户',
  register: '注册',
  //signin
  login_description: '填写以下字段以登录您的账户。',
  no_account_yet: '还没有账户？',
  signup_here: '在此注册',
  wrong_credentials: '提供的凭据错误',
  lost_password: '忘记密码？',
  //work-orders
  link_wo: '链接工单',
  link_wo_description: '在工单之间创建关系',
  required_relationType: '选择关系类型。',
  required_wo: '工单字段是必需的。',
  this_wo: '此工单',
  the_wo: '该工单',
  link: '链接',
  cost_description: '成本描述',
  assigned_to: '分配给',
  category: '类别',
  date: '日期',
  cost: '成本',
  include_cost: '将此成本包含在总成本中',
  include_cost_description: '这将把成本添加到工单的总成本中',
  required_cost_description: '成本描述是必需的',
  required_cost: '成本是必需的',
  add_cost: '添加额外成本',
  add_cost_description: '填写以下字段以创建和添加额外成本',
  add: '添加',
  hourly_rate: '小时费率',
  include_time: '将此时间包含在总时间中',
  include_time_description: '这将把持续时间添加到工单的总时间中',
  work_started_at: '工作开始时间',
  duration: '持续时间',
  hours: '小时',
  minutes: '分钟',
  required_hours: '小时字段是必需的',
  required_minutes: '分钟字段是必需的',
  add_time: '添加时间',
  add_time_description: '填写以下字段以创建和添加时间',
  feedback: '反馈',
  feedback_description: '提供您的反馈',
  required_feedback: '反馈是必需的',
  signature: '签名',
  required_signature: '图像是必需的',
  close_wo: '关闭工单',
  close: '关闭',
  task_update_success: '任务更新成功',
  task_update_failure: '任务无法更新',
  notes_save_success: '笔记保存成功',
  images_add_task_success: '图像已添加到任务',
  images_add_task_failure: '出现了问题',
  images: '图像',
  required_images: '至少上传一张图像',
  add_images: '添加图像',
  tasks: '任务',
  wo_archive_success: '工单已存档',
  wo_archive_failure: '工单无法存档',
  wo_archive_confirm: '您确定要存档此工单吗 ',
  quantity_change_success: '数量更改成功',
  quantity_change_failure: '数量无法更改',
  details: '详细信息',
  updates: '更新',
  id: 'ID',
  due_date: '截止日期',
  location: '位置',
  asset: '资产',
  team: '团队',
  created_at: '创建于',
  list_view: '列表视图',
  calendar_view: '日历视图',
  column_view: '列视图',
  wo_create_success: '工单创建成功',
  wo_create_failure: '工单无法创建',
  changes_saved_success: '更改已保存',
  wo_update_failure: '工单无法编辑',
  wo_delete_success: '工单删除成功',
  wo_delete_failure: '工单无法删除',
  status: '状态',
  title: '标题',
  priority: '优先级',
  description: '描述',
  worker: '工人',
  location_name: '位置名称',
  location_address: '位置地址',
  asset_name: '资产名称',
  days_since_creation: '创建后天数',
  files: '文件',
  requested_by: '请求者',
  completed_on: '完成于',
  updated_at: '更新于',
  work_order: '工单',
  timer_running: '计时器运行中',
  run_timer: '运行计时器',
  approved_by: '批准者',
  created_by: '创建者',
  completed_by: '完成者',
  time: '时间',
  save: '保存',
  customers: '承包商',
  no_labor:
    '尚未添加劳动成本。当用户记录时间并在{{brandName}}中保存小时费率时，它们将出现在这里。',
  not_assigned: '未分配',
  no_additional_cost: '尚未添加额外成本',
  parts: '零件',
  links: '链接',
  confirm_delete_file_wo: '您确定要从此工单中删除此文件吗？',
  archive: '存档',
  labors: '劳动',
  add_additional_cost: '添加额外成本',
  additional_costs: '额外成本',
  add_parts: '添加零件',
  'wo.title_description': '输入工单标题',
  image: '图像',
  estimated_duration: '预计持续时间（小时）',
  primary_worker: '主要工人',
  additional_workers: '其他工人',
  select_team: '选择团队',
  select_location: '选择位置',
  select_asset: '选择资产',
  select_tasks: '选择任务',
  select_pm: 'Select Preventive Maintenance routine',
  requires_signature: '需要签名',
  required_wo_title: '工单标题是必需的',
  add_wo: '添加工单',
  add_wo_description: '填写以下字段以创建和添加新工单',
  edit_wo: '编辑工单',
  edit_wo_description: '填写以下字段以更新工单',
  'noRows.wo.message': '工单是可以安排或分配给某人的任务或作业',
  'noRows.wo.action': "按'+'按钮创建工单",
  to_delete: '删除',
  confirm_delete_wo: '您确定要删除此工单吗？',
  no_access_wo: '您无权访问工单。如果您应该有访问权限，请联系您的管理员',
  cancel: '取消',
  select_parts: '选择零件',
  sets_of_parts: '零件套装',
  //preventive maintenance
  paused: '暂停',
  trigger_details: '触发器详细信息',
  starts_on: '开始于',
  ends_on: '结束于',
  frequency: '频率',
  every_frequency_days: '每{{frequency}}天',
  wo_details: '工单详细信息',
  confirm_delete_file: '您确定要删除此文件吗？',
  wo_schedule_success: '工单安排成功',
  wo_schedule_failure: '工单无法安排',
  pm_create_success: '预防性维护创建成功',
  pm_create_failure: '预防性维护无法创建',
  pm_edit_failure: '预防性维护无法编辑',
  pm_delete_success: '预防性维护删除成功',
  pm_delete_failure: '预防性维护无法删除',
  pm_name: 'PM名称',
  enter_pm_name: '输入PM名称',
  required_pm_name: 'PM名称是必需的',
  add_pm: '添加预防性维护',
  add_pm_description: '填写以下字段以创建和添加新的预防性维护',
  edit_pm: '编辑预防性维护',
  edit_pm_description: '填写以下字段以编辑预防性维护',
  confirm_delete_pm: '您确定要删除此预防性维护吗？',
  'noRows.pm.message': '预防性维护是帮助维护资产的重复任务',
  'noRows.pm.action': "按'+'按钮创建预防性维护",
  no_access_pm: '您无权访问预防性维护。如果您应该有访问权限，请联系您的管理员',
  //assets
  asset_create_success: '资产创建成功',
  asset_create_failure: '资产无法创建',
  asset_edit_failure: '资产无法编辑',
  asset_delete_success: '资产删除成功',
  asset_delete_failure: '资产无法删除',
  name: '名称',
  model: '型号',
  serial_number: '序列号',
  warranty_expiration_date: '保修到期日期',
  additional_information: '附加信息',
  enter_asset_name: '输入资产名称',
  enter_asset_model: '输入资产型号',
  enter_asset_description: '输入资产描述',
  enter_asset_serial_number: '输入资产序列号',
  enter_asset_additional_information: '输入资产附加信息',
  required_asset_name: '资产名称是必需的',
  add_asset: '添加资产',
  add_asset_description: '填写以下字段以创建和添加新资产',
  edit_asset: '编辑资产',
  edit_asset_description: '填写以下字段以编辑资产',
  confirm_delete_asset: '您确定要删除此资产吗？',
  asset_details: '资产详细信息',
  parent_asset: '父资产',
  child_assets: '子资产',
  no_child_asset: '无子资产',
  no_file_in_asset: '此资产没有关联文件',
  no_wo_in_asset: '此资产中没有工单',
  barcode: '条形码',
  enter_asset_barcode: '输入资产条形码',
  area: '区域',
  enter_asset_area: '输入资产区域',
  //locations
  location_create_success: '位置创建成功',
  location_create_failure: '位置无法创建',
  location_edit_failure: '位置无法编辑',
  location_delete_success: '位置删除成功',
  location_delete_failure: '位置无法删除',
  address: '地址',
  enter_location_name: '输入位置名称',
  enter_location_address: '输入位置地址',
  required_location_name: '位置名称是必需的',
  add_location: '添加位置',
  add_location_description: '填写以下字段以创建和添加新位置',
  edit_location: '编辑位置',
  edit_location_description: '填写以下字段以编辑位置',
  confirm_delete_location: '您确定要删除此位置吗？',
  location_details: '位置详细信息',
  parent_location: '父位置',
  child_locations: '子位置',
  no_child_location: '无子位置',
  floor_plan: '平面图',
  add_floor_plan: '添加新平面图',
  add_floor_plan_description: '填写以下字段以创建新平面图',
  no_asset_in_location: '此位置没有资产',
  no_wo_in_location: '此位置没有工单',
  no_file_in_location: '此位置没有关联文件',
  no_floor_plan_in_location: '此位置没有平面图',
  assigned_teams: '分配的团队',
  assigned_customers: '分配的承包商',
  assigned_vendors: '分配的供应商',
  //no_access
  no_access_location: '您无权访问位置。如果您应该有访问权限，请联系您的管理员',
  no_access_vendors_customers:
    '您无权访问供应商和承包商。如果您应该有访问权限，请联系您的管理员',
  no_access_people_team:
    '您无权访问人员和团队。如果您应该有访问权限，请联系您的管理员',
  no_access_analytics: '您无权访问分析。如果您应该有访问权限，请联系您的管理员',
  no_access_assets: '您无权访问资产。如果您应该有访问权限，请联系您的管理员',
  no_access_categories:
    '您无权访问类别。如果您应该有访问权限，请联系您的管理员',
  no_access_files: '您无权访问文件。如果您应该有访问权限，请联系您的管理员',
  no_access_inventory: '您无权访问库存。如果您应该有访问权限，请联系您的管理员',
  no_access_meters: '您无权访问仪表。如果您应该有访问权限，请联系您的管理员',
  no_access_purchase_orders:
    '您无法创建采购订单。如果您应该有访问权限，请联系您的管理员',
  no_access_requests: '您无权访问请求。如果您应该有访问权限，请联系您的管理员',
  no_access_settings: '您无权访问设置。如果您应该有访问权限，请联系您的管理员',
  no_access_page: '您无权访问此页面',
  file: '文件',
  'noRows.location.message': '位置让您更有效地管理资产和工人',
  'noRows.location.action': "按'+'按钮创建位置",
  //inventory
  card_view: '卡片视图',
  set_create_success: '套装创建成功',
  set_create_failure: '套装无法创建',
  set_edit_failure: '套装无法编辑',
  set_delete_success: '套装删除成功',
  set_delete_failure: '套装无法删除',
  total_cost: '总成本',
  part: '零件',
  enter_part_name: '输入零件名称',
  required_set_name: '套装名称是必需的',
  add_set: '添加套装',
  add_set_description: '填写以下字段以创建和添加新套装',
  create_set: '创建套装',
  edit_set: '编辑套装',
  edit_set_description: '填写以下字段以编辑套装',
  confirm_delete_set: '您确定要删除此套装吗？',
  part_create_success: '零件创建成功',
  part_create_failure: '零件无法创建',
  part_edit_failure: '零件无法编辑',
  part_delete_success: '零件删除成功',
  part_delete_failure: '零件无法删除',
  quantity: '数量',
  open_wo: '开放工单',
  enter_part_category: '输入零件类别',
  enter_part_cost: '输入零件成本',
  enter_part_quantity: '输入零件数量',
  minimum_quantity: '最小数量',
  enter_part_minimum_quantity: '输入零件最小数量',
  non_stock: '非库存',
  enter_part_barcode: '输入零件条形码',
  enter_part_area: '输入零件区域',
  additional_part_details: '附加零件详细信息',
  add_part: '添加零件',
  add_part_description: '填写以下字段以创建和添加新零件',
  create_part: '创建零件',
  update_part: '更新零件',
  update_part_description: '填写以下字段以更新零件',
  'noRows.part.message': '零件可以组合成资产或单独使用',
  'noRows.part.action': "按'+'按钮创建零件",
  confirm_delete_part: '您确定要删除此零件吗？',
  part_details: '零件详细信息',
  area_details: '区域详细信息',
  assigned_people: '分配的人员',
  no_asset_related_part: '没有与此零件相关的资产',
  no_file_found: '未找到文件',
  no_wo_found: '未找到工单',
  workers: '工人',
  Parts_and_Inventory: '零件和库存',
  //purchase order
  po_edit_failure: '采购订单无法编辑',
  po_delete_success: '采购订单删除成功',
  po_delete_failure: '采购订单无法删除',
  number_of_items: '项目数量',
  total_quantity: '总数量',
  shipping_to: '运送至',
  shipping_address: '运送地址',
  po_details: '采购订单详细信息',
  enter_po_name: '输入采购订单名称',
  additional_details: '附加详细信息',
  vendor: '供应商',
  shipping_information: '运送信息',
  company_name: '公司名称',
  ship_to: '运送至',
  city: '城市',
  state: '州',
  zip_code: '邮政编码',
  fax_number: '传真号码',
  po_date: '采购订单日期',
  notes: '备注',
  add_notes: '添加备注',
  requisitioner: '申请人',
  terms: '条款',
  shipping_method: '运送方式',
  required_name: '名称是必需的',
  edit_po: '编辑采购订单',
  edit_po_description: '填写以下字段以更新采购订单',
  purchase_order: '采购订单',
  'noRows.po.message': '在一个地方管理您的采购订单',
  'noRows.po.action': "按'+'按钮创建采购订单。",
  confirm_delete_po: '您确定要删除此采购订单吗？',
  upgrade_po: '升级以创建采购订单',
  new_po: '新采购订单',
  po_create_success: '采购订单创建成功',
  select_one_part: '至少选择1个零件 ',
  po_create_failure: '采购订单无法创建',
  approve_while_submitting: '提交时批准',
  invalid_fax: '传真号码无效',
  submit: '提交',
  each_item_superior_zero: '每个项目数量必须大于0',
  quantity_edit_success: '数量更改成功',
  quantity_edit_failure: '数量无法更改',
  APPROVED: '已批准',
  PENDING: '待处理',
  REJECTED: '已拒绝',
  //meter
  when_reading_is: '当仪表读数是',
  greater_than: '大于',
  lower_than: '小于',
  value: '值',
  required_value: '值是必需的',
  required_trigger_condition: '条件是必需的',
  wo_trigger_create_success: '工单触发器创建成功',
  wo_trigger_create_failure: '工单触发器无法创建',
  add_wo_trigger: '添加工单触发器',
  add_wo_trigger_description: '填写以下字段以创建和添加工单触发器',
  wo_trigger_edit_success: '工单触发器更新成功',
  meter_create_success: '仪表创建成功',
  meter_create_failure: '仪表无法创建 ',
  meter_edit_failure: '仪表无法编辑',
  meter_delete_success: '仪表删除成功',
  meter_delete_failure: '仪表无法删除',
  next_reading_due: '下次读数到期',
  unit_of_measurement: '测量单位',
  last_reading: '最后读数',
  enter_meter_name: '输入仪表名称',
  unit: '单位',
  update_frequency: '更新频率',
  update_frequency_in_days: '更新频率（天）',
  required_meter_name: '仪表名称是必需的',
  required_meter_unit: '仪表单位是必需的',
  required_meter_update_frequency: '仪表更新频率是必需的',
  required_asset: '资产是必需的',
  add_meter: '添加仪表',
  add_meter_description: '填写以下字段以创建和添加新仪表',
  edit_meter: '编辑仪表',
  edit_meter_description: '填写以下字段以编辑仪表',
  confirm_delete_meter: '您确定要删除此仪表吗？',
  upgrade_create_meter: '升级以创建仪表',
  history: '历史',
  reading_frequency: '读数频率',
  required_reading_value: '读数值是必需的',
  wo_triggers: '工单触发器',
  add_trigger: '添加触发器',
  meter_details: '仪表详细信息',
  'noRows.meter.message': '仪表读数让您能够监控资产并根据定义的条件触发新工单',
  'noRows.meter.action': "按'+'按钮创建仪表",
  meter: '仪表',
  //upload
  drag_one_file: '将一个唯一文件拖到这里',
  drag_many_files: '拖放文件到这里',
  drop_to_start: '放下文件开始上传',
  invalid_files_type: '您无法上传这些文件类型',
  you_have_uploaded: '您已上传',
  upload: '上传',
  //vendors_customers
  Vendors_Customers: '供应商和承包商',
  customer_create_success: '承包商创建成功',
  customer_create_failure: '承包商无法创建',
  customer_edit_failure: '承包商无法编辑',
  customer_delete_success: '承包商删除成功',
  customer_delete_failure: '承包商无法删除',
  customer_name: '承包商名称',
  website: '网站',
  customer_type: '承包商类型',
  customer_type_description: '例如：管道、电气',
  customer_description_description: '用几行描述此承包商的目的...',
  billing_information: '账单信息',
  address_line_2: '地址第2行',
  billing_name: '账单名称',
  currency: '货币',
  select_currency: '选择货币',
  required_customer_name: '承包商名称是必需的',
  required_phone: '电话号码是必需的',
  invalid_website: '无效网站',
  billing_address: '账单地址',
  add_customer: '添加承包商',
  add_customer_description: '填写以下字段以创建和添加新承包商',
  'noRows.customer.message': '承包商是外部工人',
  'noRows.customer.action': "按'+'按钮创建承包商",
  type: '类型',
  billing_currency: '账单货币',
  go_back: '返回',
  confirm_delete_customer: '您确定要删除此承包商吗？',
  //vendor
  vendor_create_success: '供应商创建成功',
  vendor_create_failure: '供应商无法创建',
  vendor_edit_failure: '供应商无法编辑',
  vendor_delete_success: '供应商删除成功',
  vendor_delete_failure: '供应商无法删除',
  required_company_name: '公司名称是必需的',
  vendor_type: '供应商类型',
  contact_name: '联系人姓名',
  add_vendor: '添加供应商',
  add_vendor_description: '填写以下字段以创建和添加新供应商',
  confirm_delete_vendor: '您确定要删除此供应商吗？',
  'noRows.vendor.message': '供应商是提供资产或零件的组织',
  'noRows.vendor.action': "按'+'按钮创建供应商",
  vendor_type_description: '例如：管道、电气',
  //people teams
  role: '角色',
  edit_user: '编辑用户',
  edit_user_description: '填写以下字段以编辑用户',
  job_title: '职位',
  invite_users: '邀请用户',
  bring_people_team: '为团队带来新成员',
  add_20_users:
    "您可以通过在每次电子邮件输入后按'tab'或'enter'一次添加20个用户。任何重复和已注册的电子邮件地址将在请求用户注册时被删除。",
  enter_email: '输入电子邮件地址',
  users_invite_success: '用户已邀请',
  users_invite_failure: '用户无法邀请。检查您当前的订阅成员数量',
  please_type_emails: '输入要邀请的电子邮件地址',
  please_select_role: '选择角色',
  invite: '邀请',
  team_create_success: '团队创建成功',
  team_create_failure: '团队无法创建',
  team_edit_failure: '团队无法编辑',
  team_delete_success: '团队删除成功',
  team_delete_failure: '团队无法删除',
  team_name: '团队名称',
  people_in_team: '团队成员',
  required_team_name: '团队名称是必需的',
  create_team: '创建团队',
  create_team_description: '您可以从这里添加团队成员',
  confirm_delete_team: '您确定要删除此团队吗？',
  overview: '概览',
  activity: '活动',
  wo_complete_last_14_days: '过去14天完成的工单',
  no_wo_complete_last_14_days: '您在过去两周内没有完成工单',
  ADMIN_name: '管理员',
  ADMIN_description: '管理员拥有完全访问权限；包括编辑、添加、删除工单和请求',
  LIMITED_ADMIN_name: '有限管理员',
  LIMITED_ADMIN_description:
    '有限管理员与管理员具有相同的访问权限，除了他们无法查看/编辑设置或添加/编辑人员和团队。他们无法删除工单、资产、位置、仪表和采购订单，除非他们创建了承包商、类别和PM触发器。',
  TECHNICIAN_name: '技术员',
  TECHNICIAN_description:
    '技术员可以创建和关闭工单、资产和位置。只能编辑和删除他们创建的内容',
  LIMITED_TECHNICIAN_name: '有限技术员',
  LIMITED_TECHNICIAN_description: '有限技术员只能看到分配给他们的工单',
  VIEW_ONLY_name: '仅查看',
  VIEW_ONLY_description: '仅查看用户拥有完全查看访问权限，但无法编辑任何内容',
  REQUESTER_name: '请求者',
  REQUESTER_description: '请求者只能提交工作请求并查看其状态',
  select_user_role: '选择用户角色',
  'noRows.team.message': '团队帮助您管理特定的人群。',
  'noRows.team.action': "按'+'按钮创建团队。",
  user_details: '用户详细信息',
  //files
  file_delete_success: '文件删除成功',
  file_delete_failure: '文件无法删除',
  uploaded_by: '上传者',
  uploaded_on: '上传于',
  rename: '重命名',
  required_files: '至少上传一个文件',
  required_file_name: '输入文件名',
  add_files: '添加文件',
  edit_file: '编辑文件',
  'noRows.file.message': '在一个地方获取所有文件',
  'noRows.file.action': "按'+'按钮上传文件",
  upgrade_files: '升级以在您的资产、工单、位置等中使用文件...',
  parts_consumption: '零件消耗',
  requests_analysis: '请求分析',
  //categories,
  category_create_success: '类别创建成功',
  category_create_failure: '类别无法创建',
  category_edit_failure: '类别无法编辑',
  category_delete_success: '类别删除成功',
  category_delete_failure: '类别无法删除',
  timers: '计时器',
  costs: '成本',
  add_category: '添加新类别',
  add_category_description: '填写名称以创建和添加新类别',
  edit_category: '编辑类别',
  edit_category_description: '填写名称以编辑类别',
  no_category_action: "按'+'按钮添加您的第一个类别。",
  confirm_delete_category: '您确定要删除此类别吗？',
  no_category_message: '看起来您还没有{{categoryName}}类别。',
  acquisition_cost: '采购成本',
  //settings
  general_settings: '常规设置',
  language: '语言',
  date_format: '日期格式',
  time_zone: '时区',
  request_form_configuration: '请求表单配置',
  roles: '角色',
  checklists: '检查清单',
  field_configuration_description: '您可以将字段标记为可选、隐藏或必需',
  optional: '可选',
  required: '必需',
  hidden: '隐藏',
  creating_wo: '创建工单',
  completing_wo: '完成工单',
  role_edit_failure: '角色无法编辑',
  edit_role: '编辑角色',
  edit_role_description: '填写以下字段以编辑角色',
  external_id: '外部ID',
  permissions: '权限',
  create_role_description:
    '此角色可以执行管理员在{{brandName}}中可以执行的所有操作，但您可以在下面自定义一些重要权限。',
  create_and_edit: '创建/编辑',
  to_access: '访问',
  to_create_edit: '创建/编辑',
  checklist_create_success: '检查清单创建成功',
  checklist_create_failure: '检查清单无法创建',
  checklist_edit_failure: '检查清单无法编辑',
  checklist_delete_success: '检查清单删除成功',
  checklist_delete_failure: '检查清单无法删除',
  checklist_name: '检查清单名称',
  enter_checklist_name: '输入检查清单名称',
  required_checklist_name: '检查清单名称是必需的',
  add_checklist: '添加检查清单',
  add_checklist_description: '填写以下字段以创建和添加新检查清单',
  edit_checklist: '编辑检查清单',
  edit_checklist_description: '填写以下字段以编辑检查清单',
  confirm_delete_checklist: '您确定要删除此检查清单吗？',
  'noRows.checklist.message': '检查清单帮助您标准化工作',
  'noRows.checklist.action': "按'+'按钮创建检查清单",
  task_type: '任务类型',
  task_label: '任务标签',
  enter_task_label: '输入任务标签',
  task_options: '任务选项',
  enter_task_options: '输入任务选项',
  add_task_option: '添加任务选项',
  task_notes: '任务备注',
  enter_task_notes: '输入任务备注',
  SUBTASK: '子任务',
  INSPECTION: '检查',
  METER: '仪表',
  MULTIPLE: '多选',
  NUMBER: '数字',
  TEXT: '文本',
  upgrade_checklist: '升级以创建检查清单',
  learn_more: '了解更多',
  //user profile
  profile: '个人资料',
  email_notifications: '电子邮件通知',
  email_updates_wo: '工单和通知的电子邮件更新',
  email_updates_requests: '请求工单的电子邮件更新',
  po_emails: '采购订单电子邮件',
  required_job_title: '职位字段是必需的',
  required_old_password: '输入当前密码。',
  invalid_password: '密码太短 - 必须至少8个字符。',
  required_new_password: '未提供密码。',
  passwords_must_match: '密码必须匹配',
  password_change_success: '密码更改成功',
  wrong_password: '提供的密码错误',
  current_password: '当前密码',
  new_password: '新密码',
  confirm_password: '确认密码',
  personal_details: '个人详细信息',
  personal_details_description: '管理与您的个人详细信息相关的信息',
  change_password: '更改密码',
  notification_settings: '通知设置',
  notification_settings_description: '管理与您的通知相关的详细信息',
  recent_activity: '最近活动',
  created: '已创建',
  completed: '已完成',
  my_account: '我的账户',
  my_company: '我的公司',
  you_are_using_plan:
    '您当前使用的是{{planName}}计划。它将在{{expiration}}到期。立即升级以获得更多功能。',
  upgrade_plan: '升级计划',
  //subscription
  plans: '计划',
  monthly: '月度',
  annually: '年度',
  subscription_change_success: '订阅更改成功',
  invalid_credit_card: '信用卡号无效',
  required_credit_card: '卡片字段是必需的',
  invalid_expiration_month: '到期月份无效',
  required_expiration_month: '到期月份是必需的',
  invalid_expiration_year: '到期年份无效',
  required_expiration_year: '到期年份是必需的',
  invalid_cvv: 'CVV无效',
  required_cvv: 'CVV是必需的',
  required_cardholder_name: '持卡人姓名是必需的',
  card: '卡片',
  expiration_month: '到期月份',
  expiration_year: '到期年份',
  cardholder_name: '持卡人姓名',
  seats: '席位',
  cost_per_seat: '每席位成本',
  your_payment_secure: '您的付款数据已加密且安全。',
  plan: '计划',
  current_plan: '当前计划',
  number_users_who_will_use_grash: '将使用{{shortBrandName}}的用户数量',
  admin_role: '管理员',
  technical_role: '技术',
  limited_technical_role: '有限技术',
  requester_role: '请求者',
  view_only_role: '仅查看',
  how_will_you_be_billed: '您希望如何计费？',
  which_plan_fits_you: '哪个计划最适合您？',
  per_user_month: '每用户/月',
  per_user_year: '每用户/年',
  you_will_be_charged: '您将被收费',
  proceed_to_payment: '继续付款',
  pay_only_for_roles:
    '仅为<strong>管理员</strong>、<strong>技术</strong>和<strong>有限技术</strong>用户付费，免费使用无限<strong>请求者</strong>、<strong>仅查看</strong>',
  checkout_our: '查看我们的',
  pricing_page: '定价页面',
  for_more_details: '了解更多详情',
  users_count_display: '{{count}}个用户',
  monthly_adverb: '每月',
  yearly_adverb: '每年',
  features: '功能',
  checkout: '结账',
  checkout_description: '填写以下字段',
  per_month: '每月',
  per_year: '每年',
  recover_password_description: '输入用于注册的电子邮件以重置您的密码。',
  send_me_new_password: '发送新密码',
  want_to_sign_in_again: '想要再次登录？',
  check_mails_for_instructions: '检查您的电子邮件以获取进一步说明',
  pdf_report: 'PDF报告',
  HIGH: '高',
  MEDIUM: '中',
  LOW: '低',
  NONE: '无',
  import: '导入',
  start_import_process: '开始导入过程',
  import_data: '导入数据',
  set_header: '设置标题',
  match_columns: '匹配列',
  review: '审查',
  done: '完成',
  no_match_yet: '尚未匹配',
  select: '选择...',
  matched_to_field: '匹配到{{field}}',
  next: '下一步',
  not_enough_rows: '文件中行数不足',
  there_are_duplicates: '存在重复项：{{duplicates}}',
  assigned_by: '分配者',
  percent_rows_have_value: '{{percent}}%的行有值',
  match_at_least_column: '至少匹配一列',
  to_import: '导入',
  required_match: '{{field}}匹配是必需的',
  archived: '已存档',
  import_wo_success: '{{created}}个工单已创建，{{updated}}个已更新',
  to_export: '导出',
  filters: '过滤器',
  more_filters: '更多过滤器',
  customer: '承包商',
  to: '到',
  dates: '日期',
  start: '开始',
  end: '结束',
  longitude: '经度',
  latitude: '纬度',
  ALL: '全部',
  REACTIVE: '反应性',
  REPEATING: '预防性',
  import_location_success: '{{created}}个位置已创建，{{updated}}个已更新',
  import_part_success: '{{created}}个零件已创建，{{updated}}个已更新',
  import_meter_success: '{{created}}个仪表已创建，{{updated}}个已更新',
  import_asset_success: '{{created}}个资产已创建，{{updated}}个已更新',
  wo_calendar: '工单日历',
  month: '月',
  week: '周',
  day: '日',
  agenda: '议程',
  previous: '上一个',
  today: '今天',
  to_filter: '过滤',
  'noRows.asset.message': '资产是您的公司可以干预的资源',
  'noRows.asset.action': "按'+'按钮创建新资产。",
  reset_filters: '重置过滤器',
  toggle_menu: '切换菜单',
  no_results: '未找到结果',
  an_error_occured: '发生错误。',
  density: '密度',
  compact: '紧凑',
  standard: '标准',
  comfortable: '舒适',
  columns: '列',
  select_columns: '选择列',
  show_filters: '显示过滤器',
  hide_filters: '隐藏过滤器',
  search_placeholder: '搜索…',
  search: '搜索',
  clear: '清除',
  download_as_csv: '下载为CSV',
  print: '打印',
  download_as_excel: '下载为Excel',
  find_column: '查找列',
  column_title: '列标题',
  reorder_column: '重新排序列',
  show_all: '显示全部',
  hide_all: '隐藏全部',
  add_filter: '添加过滤器',
  logic_operator: '逻辑运算符',
  operator: '运算符',
  and: '和',
  or: '或',
  filter_value: '过滤值',
  contains: '包含',
  equals: '等于',
  starts_with: '开始于',
  ends_with: '结束于',
  is: '是',
  is_not: '不是',
  is_after: '在之后',
  is_on_or_after: '在或之后',
  is_before: '在之前',
  is_on_or_before: '在或之前',
  is_empty: '为空',
  is_not_empty: '不为空',
  is_any_of: '是其中任何一个',
  any: '任何',
  true_text: '真',
  false_text: '假',
  menu: '菜单',
  show_columns: '显示列',
  hide: '隐藏',
  unsort: '取消排序',
  sort_by_ASC: '按ASC排序',
  sort_by_DESC: '按DESC排序',
  sort: '排序',
  total_rows: '总行数：',
  yes: '是',
  no: '否',
  more: '更多',
  to_group: '分组',
  see_children: '查看子项',
  hide_children: '隐藏子项',
  expand: '展开',
  collapse: '折叠',
  detail_panel_toggle: '详细面板切换',
  cancel_subscription: '取消订阅',
  resume_subscription: '恢复订阅',
  confirm_cancel_subscription: '您确定要取消订阅吗？',
  workflows: '工作流',
  create_workflow: '创建工作流',
  if: '如果',
  and_optional: '和（可选）',
  then: '那么',
  workflow_description:
    '创建自定义工作流就像如果、和、那么一样简单。节省时间并通过工作流自动分配您的工单，以自定义{{shortBrandName}}适应您团队的工作方式。\n所有计划都可以创建最多1个自定义工作流。要添加其他工作流，请升级到我们的商业计划',
  CREATE_PURCHASE_ORDER: '创建采购订单',
  PART_IS: '零件是',
  QUANTITY_INFERIOR: '数量少于',
  ASSIGN_VENDOR: '分配供应商',
  ASSIGN_CATEGORY: '分配类别',
  APPROVE: '批准',
  REJECT: '拒绝',
  SEND_REMINDER_EMAIL: '发送提醒电子邮件',
  VENDOR_IS: '供应商是',
  CATEGORY_IS: '类别是',
  STATUS_IS: '状态是',
  DUE_DATE_BETWEEN: '截止日期在之间',
  DUE_DATE_AFTER: '截止日期在之后',
  ASSIGN_PRIORITY: '分配优先级',
  ASSIGN_ASSET: '分配资产',
  ASSIGN_LOCATION: '分配位置',
  ASSIGN_USER: '分配用户',
  ASSIGN_TEAM: '分配团队',
  ADD_CHECKLIST: '添加检查清单',
  PRIORITY_IS: '优先级是',
  ASSET_IS: '资产是',
  LOCATION_IS: '位置是',
  USER_IS: '用户是',
  TEAM_IS: '团队是',
  CREATED_AT_BETWEEN: '创建于之间',
  TITLE_CONTAINS: '标题包含',
  CREATE_REQUEST: '创建请求',
  CREATE_WORK_ORDER: '创建工单',
  SET_ASSET_STATUS: '设置资产状态',
  NAME_IS: '名称是',
  NAME_CONTAINS: '名称包含',
  VALUE_IS: '值是',
  VALUE_CONTAINS: '值包含',
  NUMBER_VALUE_SUPERIOR: '值大于',
  NUMBER_VALUE_INFERIOR: '值小于',
  WORK_ORDER_CREATED: '工单已创建',
  WORK_ORDER_CLOSED: '工单已关闭',
  WORK_ORDER_ARCHIVED: '工单已存档',
  REQUEST_CREATED: '请求已创建',
  REQUEST_APPROVED: '请求已批准',
  REQUEST_REJECTED: '请求已拒绝',
  PURCHASE_ORDER_CREATED: '采购订单已创建',
  PURCHASE_ORDER_UPDATED: '采购订单已更新',
  TASK_UPDATED: '任务已更新',
  PART_UPDATED: '零件已更新',
  add_condition: '添加条件',
  workflow_creation_success: '工作流创建成功',
  workflow_creation_failure: '工作流创建失败',
  action_value_missing: '操作值缺失',
  condition_value_missing: '条件值缺失',
  workflow_edit_success: '工作流更新成功',
  workflow_edit_failure: '工作流无法编辑',
  workflow_delete_success: '工作流删除成功',
  workflow_delete_failure: '工作流无法删除',
  confirm_delete_workflow: '您确定要删除此工作流吗',
  click_here: '点击这里',
  verify_email_title: '验证电子邮件',
  verify_email_description:
    '验证电子邮件已发送给您。如果在收件箱中看不到，请检查垃圾邮件。',
  upgrade: '升级',
  downgrade: '降级',
  upgrade_description:
    '您刚刚升级了订阅计划。您需要启用可能使用{{shortBrandName}}的禁用用户。您只能为当前订阅执行一次此操作。请仔细选择',
  enable_users: '启用用户',
  max_users_description: '您最多可以启用{{maxUsers}}个用户',
  downgrade_description:
    '您刚刚降级了订阅计划。您需要禁用一些用户才能继续。您只能为当前订阅执行一次此操作。请仔细选择',
  disable_users: '禁用用户',
  min_users_description: '您必须至少禁用{{minUsers}}个用户',
  downgrade_description_no_owner:
    '您的公司刚刚降级了订阅计划。公司所有者需要在您继续之前禁用一些用户',
  past_due: '逾期',
  due_date_delay: '截止日期延迟',
  due_date_delay_description: '截止日期延迟天数',
  days_count: '{{days}}天',
  trigger_configuration: '触发器配置',
  WORK_ORDER_feature: '工单',
  REQUEST_feature: '工作请求',
  PART_feature: '零件管理',
  MOBILE_APP_feature: '移动应用',
  WORK_ORDER_HISTORY_feature: '工单历史',
  PREVENTIVE_MAINTENANCE_feature: '预防性维护',
  CHECKLIST_feature: '检查清单',
  FILE_feature: '文件上传',
  PURCHASE_ORDER_feature: '采购订单',
  METER_feature: '仪表读数',
  REQUEST_CONFIGURATION_feature: '请求表单配置',
  ADDITIONAL_TIME_feature: '高级时间跟踪',
  ADDITIONAL_COST_feature: '高级成本跟踪',
  ANALYTICS_feature: '分析和报告',
  REQUEST_PORTAL_feature: '请求门户',
  SIGNATURE_feature: '签名',
  ROLE_feature: '自定义角色',
  WORKFLOW_feature: '工作流自动化',
  API_ACCESS_feature: 'API访问',
  WEBHOOK_feature: 'Webhooks',
  add_new_option: '添加新选项',
  edit_company: '编辑公司',
  fill_fields_below: '填写以下字段',
  IMPORT_CSV_feature: 'CSV导入',
  no_import_access: '升级您的计划以从CSV、Excel文件导入',
  register_here: '在此注册',
  home: '首页',
  user: '用户',
  start_work_order: '开始工单',
  priority_label: '{{priority}}优先级',
  stop_work_order: '停止计时器',
  required_files_on_completion: '工单完成时需要文件',
  required_tasks_on_completion: '任务必须完成',
  required_labor_on_completion: '您必须记录时间',
  required_part_on_completion: '此工单中未使用零件',
  required_cost_on_completion: '此工单中未提供成本信息',
  complete_work_order: '完成工单',
  no_parts: '无零件',
  edit_quantity: '编辑数量',
  remaining_tasks: '{{count}}个剩余任务',
  complete_tasks_percent: '{{percent}}%完成',
  create_work_order: '创建工单',
  select_customers: '选择客户',
  select_vendors: '选择供应商',
  select_users: '选择用户',
  select_teams: '选择团队',
  select_locations: '选择位置',
  select_assets: '选择资产',
  select_categories: '选择类别',
  estimated_hours_in_text: '{{hours}}预计小时',
  create_meter: '创建仪表',
  create_location: '创建位置',
  create_request: '创建请求',
  add_task: '添加任务',
  select_task_type: '选择任务类型',
  assign_user: '分配用户',
  assign_asset: '分配资产',
  add_options: '添加选项',
  required_task_label: '任务标签是必需的',
  edit_work_order: '编辑工单',
  confirmation: '确认',
  LATE_WO: '延迟',
  TODAY_WO: '今天',
  HIGH_WO: '高优先级',
  no_element_match_criteria: '没有元素符合此条件',
  required_part_name: '零件名称是必需的',
  only_assigned_to_me: '仅分配给我',
  complete_work_orders: '完成工单',
  this_week: '本周',
  all_time: '所有时间',
  compliant_work_orders: '合规工单',
  stats: '统计',
  vendors_and_customers: '供应商和承包商',
  no_notification_message: '重要更新将出现在这里，帮助您跟踪工作进度',
  no_notification: '无通知',
  view_children: '查看子项',
  loading: '加载中',
  please_wait: '请稍候...',
  add_file: '添加文件',
  asset_update_failure: '资产无法编辑',
  no_wo_linked_location: '此位置没有工单',
  confirm_delete_file_location: '您确定要从此位置删除此文件吗？',
  confirm_delete_file_part: '您确定要从此零件删除此文件吗？',
  no_wo_linked_part: '没有工单链接到此零件',
  edit_customer: '编辑承包商',
  edit_vendor: '编辑供应商',
  reading_history: '读数历史',
  user_invite_success: '用户已邀请',
  user_invite_failure: '用户无法邀请',
  create_child_asset: '创建子资产',
  not_enough_part: '此零件不足',
  update_profile: '更新个人资料',
  confirm_logout: '您确定要注销吗？',
  report: '报告',
  end_cannot_be_ulterior_to_start: '结束日期不能早于开始日期',
  storage_permission_needed_description: '您需要授予存储权限才能下载文件',
  permission_denied: '权限被拒绝！',
  to_scan: '扫描',
  nfc_tag: 'NFC标签',
  scanning: '扫描中',
  error: '错误',
  tag_not_found: '未找到标签',
  'no nfc support': '不支持NFC',
  remaining_parts: '剩余{{quantity}}',
  team_members_count: '{{count}}名成员',
  no_asset_found_nfc: '未找到具有此NFC标签的资产。您想创建一个吗？',
  no_access_to_camera: '无法访问相机',
  no_asset_found_barcode: '未找到具有此条形码的资产。您想创建一个吗？',
  remove_blank_meter_tasks: '选择一个仪表',
  no_notification_permission: '无通知权限',
  OPERATIONAL: '运行中',
  DOWN: '停机',
  MODERNIZATION: '现代化',
  STANDBY: '待机',
  INSPECTION_SCHEDULED: '已安排检查',
  COMMISSIONING: '调试',
  EMERGENCY_SHUTDOWN: '紧急停机',
  asset_status: '资产状态',
  downtime_duration: '停机时间',
  downtime_duration_in_hours: '停机时间（小时）',
  downtime_duration_in_days: '停机时间（天）',
  downtime_duration_in_minutes: '停机时间（分钟）',
  asset_status_change_success: '资产状态更改成功',
  asset_status_change_failure: '资产状态无法更改',
  set_asset_status: '设置资产状态',
  set_asset_status_description: '设置资产的状态',
  asset_status_history: '资产状态历史',
  no_asset_status_history: '无资产状态历史',
  asset_status_changed_to: '资产状态已更改为{{status}}',
  asset_status_changed_by: '资产状态由{{user}}更改',
  asset_status_changed_on: '资产状态在{{date}}更改',
  asset_status_changed_from_to: '资产状态从{{from}}更改为{{to}}',
  asset_status_changed_from_to_by: '资产状态由{{user}}从{{from}}更改为{{to}}',
  asset_status_changed_from_to_on: '资产状态在{{date}}从{{from}}更改为{{to}}',
  asset_status_changed_from_to_by_on:
    '资产状态由{{user}}在{{date}}从{{from}}更改为{{to}}',
  asset_status_changed_from_to_by_on_with_downtime:
    '资产状态由{{user}}在{{date}}从{{from}}更改为{{to}}，停机时间为{{downtime}}',
  asset_status_changed_from_to_on_with_downtime:
    '资产状态在{{date}}从{{from}}更改为{{to}}，停机时间为{{downtime}}',
  asset_status_changed_from_to_by_with_downtime:
    '资产状态由{{user}}从{{from}}更改为{{to}}，停机时间为{{downtime}}',
  asset_status_changed_from_to_with_downtime:
    '资产状态从{{from}}更改为{{to}}，停机时间为{{downtime}}',
  asset_status_changed_to_by: '资产状态由{{user}}更改为{{status}}',
  asset_status_changed_to_on: '资产状态在{{date}}更改为{{status}}',
  asset_status_changed_to_by_on: '资产状态由{{user}}在{{date}}更改为{{status}}',
  asset_status_changed_to_with_downtime:
    '资产状态更改为{{status}}，停机时间为{{downtime}}',
  asset_status_changed_to_by_with_downtime:
    '资产状态由{{user}}更改为{{status}}，停机时间为{{downtime}}',
  asset_status_changed_to_on_with_downtime:
    '资产状态在{{date}}更改为{{status}}，停机时间为{{downtime}}',
  asset_status_changed_to_by_on_with_downtime:
    '资产状态由{{user}}在{{date}}更改为{{status}}，停机时间为{{downtime}}',
  asset_status_changed_by_on: '资产状态由{{user}}在{{date}}更改',
  asset_status_changed_by_with_downtime:
    '资产状态由{{user}}更改，停机时间为{{downtime}}',
  asset_status_changed_on_with_downtime:
    '资产状态在{{date}}更改，停机时间为{{downtime}}',
  asset_status_changed_by_on_with_downtime:
    '资产状态由{{user}}在{{date}}更改，停机时间为{{downtime}}',
  asset_status_changed_with_downtime: '资产状态已更改，停机时间为{{downtime}}',
  asset_status_changed: '资产状态已更改',
  asset_status_changed_from: '资产状态从{{from}}更改',
  asset_status_changed_from_by: '资产状态由{{user}}从{{from}}更改',
  asset_status_changed_from_on: '资产状态在{{date}}从{{from}}更改',
  asset_status_changed_from_by_on: '资产状态由{{user}}在{{date}}从{{from}}更改',
  asset_status_changed_from_with_downtime:
    '资产状态从{{from}}更改，停机时间为{{downtime}}',
  asset_status_changed_from_by_with_downtime:
    '资产状态由{{user}}从{{from}}更改，停机时间为{{downtime}}',
  asset_status_changed_from_on_with_downtime:
    '资产状态在{{date}}从{{from}}更改，停机时间为{{downtime}}',
  asset_status_changed_from_by_on_with_downtime:
    '资产状态由{{user}}在{{date}}从{{from}}更改，停机时间为{{downtime}}',
  upgrade_request_received: '升级请求已收到！我们将很快与您联系提供付款详情',
  continue_with_sso: '使用SSO继续',
  see_live_demo: '查看实时演示',
  demo_warning:
    '此实例处于演示模式。请勿将其用于真实数据！所有内容将定期删除！',
  Statistics: '统计',
  requests: '请求',
  assets: '资产',
  locations: '位置',
  parts_and_inventory: '备件 / 库存',
  purchase_orders: '采购订单',
  meters: '仪表',
  people_teams: '人员与团队',
  vendors_customers: '供应商与承包商',
  categories: '分类',
  settings: '设置',
  people: '人员',
  teams: '团队',
  vendors: '供应商',
  csv_separator: 'CSV分隔符',
  open_source_cmms: '开源 CMMS',
  'main.title': '免费开源 CMMS（维护管理软件）',
  'home.h1': '您可以自托管或在云端使用的免费开源 CMMS',
  'home.h2': '功能强大且成本低廉的维护',
  'home.h3':
    '停止依赖电子表格和白板。{{brandName}} 帮助维护团队计划干预、跟踪设备并保持合规。在您的服务器上自托管或立即在云端开始。',
  talk_to_sales: '与销售联系',
  'pricing.choose_plan_and_get_started': '选择您的套餐并开始使用',
  'pricing.slogan_effective_maintenance':
    '我们的软件为维护和可靠性团队提供了高效运行运营所需的工具。',
  'pricing.compare_plans_and_pricing': '比较方案和价格',
  'pricing.see_which_plan_is_right_for_you': '看看哪个方案最适合你',
  'pricing.select_two_plans_to_compare': '选择 2 个方案进行比较',
  'pricing.select_three_plans_to_compare': '选择 3 个方案进行比较',
  'pricing.month_per_user': '每用户每月',
  'pricing.year_per_user': '每用户每年',
  'pricing.plan_basic_name': '基本的',
  'pricing.plan_basic_description':
    '团队希望跟踪资产并制定基本的预防性维护计划和程序。',
  'pricing.feature_unlimited_work_orders': '无限量工作订单',
  'pricing.feature_custom_tasks': '自定义任务',
  'pricing.feature_unlimited_request_user_licenses': '无限制用户许可申请',
  'pricing.plan_starter_name': '起动机',
  'pricing.plan_starter_description':
    '团队希望通过机器状态和人力资源可视化来构建高效、强大的预防性维护体系。',
  'pricing.feature_everything_in_basic_plus': 'Basic Plus 包含以下所有内容：',
  'pricing.feature_preventive_maintenance_recurring_work_orders':
    '预防性维护/定期工作单',
  'pricing.feature_custom_checklists': '自定义清单',
  'pricing.feature_inventory_management_costing': '库存管理/成本核算',
  'pricing.feature_time_and_manpower_tracking': '时间和人力跟踪',
  'pricing.feature_thirty_day_analytics_reporting': '30 天分析与报告',
  'pricing.plan_professional_name': '专业的',
  'pricing.plan_professional_description':
    '需要利用洞察力和分析来推动维护业务进一步增长和提高生产力的部门。',
  'pricing.feature_everything_in_starter_plus':
    'Starter Plus 版包含的所有内容：',
  'pricing.feature_multiple_inventory_lines': '多条库存线',
  'pricing.feature_customizable_request_portal': '可定制请求门户',
  'pricing.feature_mobile_offline_mode': '移动离线模式',
  'pricing.feature_advanced_analytics_reporting': '高级分析与报告',
  'pricing.plan_business_name': '商业',
  'pricing.plan_business_description':
    '准备收集维护和运营数据以管理多个地点和系统定制的组织。',
  'pricing.feature_everything_in_professional_plus': '专业版及以上所有功能：',
  'pricing.feature_purchase_order_management': '采购订单管理',
  'pricing.feature_multi_site_module_support': '多站点模块支持',
  'pricing.feature_custom_work_order_statuses': '定制工单状态',
  'pricing.feature_custom_integrations_support': '自定义集成支持',
  'pricing.feature_work_order_management': '工单管理',
  'pricing.feature_recurring_work_orders': '重复性工作订单',
  'pricing.feature_custom_categories': '自定义类别',
  'pricing.feature_data_importing': '数据导入',
  'pricing.feature_time_and_cost_tracking': '时间和成本跟踪',
  'pricing.feature_work_order_configuration': '工单配置',
  'pricing.feature_internal_requests': '内部请求',
  'pricing.feature_external_request_portal': '外部请求门户',
  'pricing.category_locations_assets_parts': '地点、资产和部件',
  'pricing.feature_location_management': '位置管理',
  'pricing.feature_barcode_scanning': '条形码扫描',
  'pricing.feature_inventory_management': '库存管理',
  'pricing.feature_custom_asset_statuses': '自定义资产状态',
  'pricing.feature_asset_downtime_tracking': '资产停机时间跟踪',
  'pricing.feature_asset_depreciation_tracking': '资产折旧跟踪',
  'pricing.feature_asset_warranty_tracking': '资产保修跟踪',
  'pricing.feature_purchase_orders_management': '采购订单',
  'pricing.feature_asset_check_in_out': '资产登记入库/出库',
  'pricing.category_mobile_offline': '移动离线',
  'pricing.feature_work_order_availability': '工作订单可用性',
  'pricing.feature_updating_status': '正在更新状态',
  'pricing.feature_updating_tasks': '更新任务',
  'pricing.feature_work_order_drafts': '工作单草稿',
  'pricing.feature_full_drill_down_reporting_history':
    '完整的钻取式报告和历史记录',
  'pricing.period_thirty_days': '30天',
  'pricing.period_full': '满的',
  'pricing.feature_pdf_csv_exporting': 'PDF 和 CSV 导出',
  'pricing.feature_itemized_time_reporting': '逐项工时报告',
  'pricing.feature_user_login_reports': '用户登录报告',
  'pricing.feature_parts_consumption_reports': '零部件消耗报告',
  'pricing.feature_asset_downtime_reports': '资产停机报告',
  'pricing.feature_equipment_reliability_reports': '设备可靠性报告',
  'pricing.feature_multi_site_modules': '多站点模块',
  'pricing.category_integrations': '集成',
  'pricing.feature_business_integrations':
    '业务集成（SAP/Oracle/Causal AI...）',
  'pricing.feature_custom_integrations': '自定义集成',
  'pricing.feature_unlimited_view_only_users': '无限制的只读用户',
  'pricing.feature_unlimited_requesters': '无限请求者',
  'pricing.feature_unlimited_vendors': '无限供应商',
  'pricing.feature_unlimited_customers': '无限客户',
  'pricing.category_support': '支持',
  'pricing.feature_daily_email_digest': '每日邮件摘要',
  'pricing.feature_articles': '文章',
  'pricing.feature_training_webinars': '培训网络研讨会',
  'pricing.feature_community_support_discord': '社区支持（Discord）',
  'pricing.feature_email_support': '电子邮件支持',
  'pricing.feature_chat_phone_support': '在线聊天/电话支持',
  'pricing.feature_priority_support': '优先支持',
  'pricing.feature_implementation_training': '实施与培训',
  'pricing.feature_dedicated_account_manager': '专属客户经理',
  'pricing.category_customization': '定制',
  'pricing.feature_custom_development': '定制开发',
  'pricing.sh_plan_basic_name': '基本的',
  'pricing.sh_plan_basic_description':
    '适用于需要对其自身基础设施拥有完全数据主权和基本维护跟踪的小型团队。',
  'pricing.sh_feature_core_work_order_management': '核心工单管理',
  'pricing.sh_feature_asset_inventory_tracking': '资产与库存跟踪',
  'pricing.sh_feature_local_data_storage': '本地数据存储',
  'pricing.sh_plan_professional_name': '专业的',
  'pricing.sh_plan_professional_description':
    '非常适合种植需要高级检查清单、工作流程和更深入的系统集成的植物。',
  'pricing.sh_feature_everything_in_basic_plus':
    'Basic Plus 包含以下所有内容：',
  'pricing.sh_feature_unlimited_assets_checklists': '无限资产/清单',
  'pricing.sh_feature_nfc_barcode_scanning': 'NFC和条形码扫描',
  'pricing.sh_feature_email_support': '电子邮件支持',
  'pricing.sh_plan_business_name': '商业',
  'pricing.sh_plan_business_description':
    '需要多实例管理、定制品牌和顶级安全性的全面运营。',
  'pricing.sh_feature_everything_in_professional_plus':
    '专业版及以上所有功能：',
  'pricing.sh_feature_multi_instance_management': '多实例管理',
  'pricing.sh_feature_custom_user_roles': '自定义用户角色',
  'pricing.sh_feature_priority_implementation_support': '优先实施支持',
  'pricing.faq_free_users_q': '哪些类型的用户属于免费用户？',
  'pricing.faq_free_users_a1': '有三种用户类型不需要付费许可证：',
  'pricing.faq_view_only_users_title': '仅查看用户',
  'pricing.faq_view_only_users_description':
    '这些用户通常是主管，他们不经常登录查看维护活动的概览。他们还可以提交工作请求和生成报告。',
  'pricing.faq_requester_users_title': '请求用户',
  'pricing.faq_requester_users_description':
    '这些用户只能提交工作请求并查看请求状态。他们无法查看工单、资产、零件或存储在 CMMS 中的任何其他数据。',
  'pricing.faq_third_party_users_title': '第三方用户',
  'pricing.faq_third_party_users_description':
    '这些用户通常是供应商和承包商。他们实际上无法登录系统。他们只能通过公开链接提交与其关联的特定工单的更新信息。',
  'pricing.faq_paid_users_q': '哪些类型的用户属于付费用户？',
  'pricing.faq_paid_users_a1': '有三种用户类型需要付费许可证：',
  'pricing.faq_admin_users_title': '管理员用户',
  'pricing.faq_admin_users_description':
    '这些用户可以向账户添加其他成员、接受或拒绝工作请求以及编辑工单详情。他们是账户的控制用户。每个账户可以设置多个管理员。',
  'pricing.faq_technical_users_title': '技术用户',
  'pricing.faq_technical_users_description':
    '这些用户通常是现场负责完成工单的技术人员。他们可以编辑自己创建的工单，但不能编辑其他工单。他们可以向工单添加图片和状态更新，也可以创建新的工单。',
  'pricing.faq_limited_technical_users_title': '有限技术用户',
  'pricing.faq_limited_technical_users_description':
    '这些用户拥有与技术用户相同的权限。唯一的区别是，他们只能看到分配给他们的工单，而看不到账户上其他技术用户的工作订单。',
  'pricing.faq_change_plans_q': '我之后可以更改计划吗？',
  'pricing.faq_change_plans_a':
    '是的，您可以随时升级或降级您的套餐。更改将在您的下一个账单周期开始时生效。',
  'pricing.faq_free_trial_q': '有免费试用吗？',
  'pricing.faq_free_trial_a':
    '是的，我们提供 15 天的商务计划免费试用期，以便您在做决定前体验所有功能。',
  'pricing.faq_non_profit_discounts_q': '你们为非营利组织提供折扣吗？',
  'pricing.faq_non_profit_discounts_a':
    '是的，我们为非营利组织提供特价优惠。请联系我们的销售团队了解更多信息。',
  'pricing.faq_payment_methods_q': '你们接受哪些付款方式？',
  'pricing.faq_payment_methods_a':
    '我们接受所有主流信用卡、银行转账和PayPal付款。对于企业套餐，我们还可以安排开具发票。',
  'pricing.faq_cancel_subscription_q': '我可以取消订阅吗？',
  'pricing.faq_cancel_subscription_a':
    '是的，您可以随时取消订阅。取消后，您仍可继续使用服务直至当前账单周期结束。',
  'pricing.faq_data_secure_q': '我的数据安全吗？',
  'pricing.faq_data_secure_a':
    '是的，我们非常重视数据安全。所有数据在传输和存储过程中均进行加密，并且我们会定期进行安全审计。',
  'pricing.faq_title': '常见问题解答',
  'pricing.annually_save_two_months': '每年（节省 2 个月）',
  'pricing.most_popular': '最受欢迎',
  'pricing.get_your_license': '获得驾照',
  get_started: '开始使用',
  workflow_automation: '工作流自动化',
  push_notifications: '推送通知',
  cloud: '云',
  self_hosted: '自托管',
  full: '满的',
  pricing: '定价',
  industries: '行业',
  work_order_management: '工单管理',
  inventory_management: '库存管理',
  analytics_and_reporting: '分析与报告',
  manufacturing: '制造业',
  facility_management: '设施管理',
  food_and_beverage: '餐饮业',
  healthcare: '医疗保健',
  energy_and_utilities: '能源与公用事业',
  education: '教育',
  hospitality: '酒店餐饮',
  construction: '建筑业',
  upload_telemetry: 'Upload Telemetry',
  telemetry_dialog_title: 'Upload Telemetry File',
  telemetry_dialog_subtitle:
    'Select an Excel file with Placa, Kilometraje Final and Horómetro Final columns.',
  telemetry_uploading: 'Uploading…',
  telemetry_upload_success: 'Telemetry uploaded successfully',
  telemetry_upload_failure: 'Telemetry upload failed',
  telemetry_no_rows: 'No data rows found. Check that the sheet has a "Placa" header.',
  telemetry_result: 'Upload summary',
  telemetry_assets_updated: 'Assets updated',
  telemetry_readings_created: 'Readings created',
  telemetry_meters_created: 'Meters auto-created',
  telemetry_not_found: 'Unmatched plates',
  telemetry_ambiguous: 'Ambiguous plates (skipped)'
};

export default locale;
